import React, { Component } from "react";

import ReactGA from 'react-ga';
import Amplify, {API } from "aws-amplify";

import "./Home.css";

import { qset, repairset } from  "./exampleqs.js";

import EQuestion from "./EQuestion.js";
import EResult   from "./EResult.js";
import EStatus   from "./EStatus.js";

const devenv=false;

Amplify.configure({
  API: {
    endpoints: [
      {name: "consult",
       endpoint: devenv ? "http://localhost:4000" : "https://5wb20rw24l.execute-api.us-east-1.amazonaws.com/prod", 
       region: "us-east-1"} ]}});


export default class Home extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      answers: new Set(),
      goodq: [qset[0].key]
    };

    this.gaInit=false;
  }
    
  async componentDidMount() {
    this.setState({ isLoading: false });
    if ( ! devenv ) {
      if ( ! this.gaInit )
	ReactGA.initialize('UA-147574263-1');
      ReactGA.pageview('/linkdemo'+window.location.pathname + window.location.search);
    }
  }

  doConsult() {

    let assertstr =[];
    const a=this.state.answers;    
    a.forEach( x => {
      let [k,v] = JSON.parse(x);
      assertstr.push( '(' + k + ' ' + v + ')' );
    });
    console.log(assertstr);
    
    this.setState({ isLoading: true });
    API.post("consult", "/consult",
	     {
	       body: {
		 action: "assert",
		 messages: assertstr}
	     }
	    )
      .then(x=> {console.log("api ret", x);
		 const a = x.trim();
		 this.setState({goodq: [a] });
		 this.setState({ isLoading: false });
		},
	    e=>console.log(e));
  }

  hUpdate(key, label, event) {
    const statekey =  JSON.stringify([key , label]);
    let a=this.state.answers;
    if (event.target.checked)
      a.add(statekey);
    else
      a.delete(statekey);
    this.setState({answers: a });
    console.log( a);

    this.doConsult();

  }  


  renderQ(q) {
    return (<EQuestion
	    title={q.title}
	    ckey={q.key}
	    content={q.content}
	    options={q.ans}
	    hUpdate={this.hUpdate.bind(this)}
	    hi={this.state.goodq.includes(q.key)}
	    attent={this.state.goodq[0] === q.key}
	    />); 
  }

  renderR(q) {
    return (<EResult
	    title="suggested repair"
	    content={q.content}
	    hi={this.state.goodq.includes(q.key)}
	    attent={this.state.goodq[0] === q.key}
	    />  ); 
  }
  
  renderQs() {
    return qset.map( q  => this.renderQ(q));
  }

  renderLander() {
    return (
	<div className="lander">
	<EStatus
      loading={this.state.isLoading}
	/>
        <h1>Troubleshooting Linking Errors on Linux </h1>
        <p>Expert system</p>
	<p>Made by: Bojan Nikolic <a href="bojan@bnikolic.co.uk"> bojan@bnikolic.co.uk</a></p>
	{this.renderQs()}
        <h2> Solutions: </h2>
        {repairset.map(r=>this.renderR(r)) }
        </div>
	
    );
  }


  render() {
    return (
      <div className="Home">
        {this.renderLander() }
      </div>
    );
  }
}
